var map = {
	"./CheckMark_large.svg": "c67a",
	"./CheckMark_small.svg": "c4f4",
	"./ChuncheBase.svg": "1cd2",
	"./Ellipse.svg": "5ee6",
	"./Ellipse_bold_transparent.svg": "3b50",
	"./Ellipse_transparent.svg": "1dce",
	"./ProductHunt.svg": "eb21",
	"./algorithm.svg": "751c",
	"./angel.svg": "46f6",
	"./arrow_down-pink.svg": "679c",
	"./arrow_down.svg": "ccd8",
	"./arrow_right.svg": "adc4",
	"./bank.svg": "4b93",
	"./check-mark_pink.svg": "3186",
	"./dotes_11x19.svg": "4cab",
	"./dotes_12x18.svg": "e3ae",
	"./dotes_4x4.svg": "3641",
	"./dotes_6x10.svg": "d805",
	"./dotes_8x4.svg": "ef03",
	"./dotes_9x10.svg": "1912",
	"./exchanges/binance.svg": "11b1",
	"./exchanges/bitfinex.svg": "8766",
	"./exchanges/bitmex.svg": "284e",
	"./exchanges/bittrex.svg": "5da4",
	"./exchanges/coinbase.svg": "3aaf",
	"./exchanges/gateio.svg": "702d",
	"./exchanges/hitbtc.svg": "f4f6",
	"./exchanges/huobipro.svg": "eaa1",
	"./exchanges/kraken.svg": "e127",
	"./exchanges/okex.svg": "d1c9",
	"./exchanges/poloniex.svg": "c2e9",
	"./exchanges/upbit.svg": "9b4b",
	"./facebook.svg": "8b07",
	"./graph.svg": "2000",
	"./instagram.svg": "07fb",
	"./institute.svg": "b42c",
	"./linkedin.svg": "277b",
	"./medium-share.svg": "1617",
	"./people.svg": "f2de",
	"./peoples.svg": "b614",
	"./rectangle_bold_transparent_rounded.svg": "b7da",
	"./rectangle_transparent.svg": "9043",
	"./rectangle_transparent_rounded.svg": "552f",
	"./rocket.svg": "df02",
	"./safe.svg": "b434",
	"./star.svg": "0a83"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";